// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   ResearchPage.responsive.css
   Responsive Stylesheet for Pharmacology & Molecular Simulation Lab
   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED
   ========================================================================== */

/* ==========================================================================
   IPAD & TABLETS (max-width: 1024px)
   ========================================================================== */
@media (max-width: 1024px) {
  .research-page {
    width: 100%;
    max-width: 100vw;
    padding: 14px 18px 40px !important;
    overflow-x: hidden;
  }

  .research-hero,
  .research-hero-pro {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 16px !important;
    padding: 22px !important;
  }

  .research-hero h1 {
    font-size: clamp(26px, 4.2vw, 36px) !important;
    line-height: 1.1 !important;
  }

  /* Horizontal scrolling tabs */
  .research-tabs {
    display: flex !important;
    flex-wrap: nowrap !important;
    overflow-x: auto !important;
    gap: 8px !important;
    padding: 4px 2px 10px !important;
    -webkit-overflow-scrolling: touch !important;
    scrollbar-width: none !important;
  }

  .research-tabs::-webkit-scrollbar {
    display: none !important;
  }

  .research-tabs button {
    flex: 0 0 auto !important;
    min-width: 140px !important;
    padding: 10px 16px !important;
    border-radius: 10px !important;
  }

  /* Studio grids to 1 column */
  .studio-layout,
  .simulation-builder-grid,
  .impact-explorer-grid,
  .molecular-studio-shell {
    grid-template-columns: 1fr !important;
    gap: 18px !important;
  }

  .studio-graph-shell,
  .studio-molecule-svg {
    height: 420px !important;
    min-height: 420px !important;
  }

  .hra-body-viewer,
  .hra-result-layout > .hra-body-viewer,
  .d3-organ-intel-panel {
    height: 420px !important;
    min-height: 420px !important;
  }
}

/* ==========================================================================
   MOBILE PHONES (max-width: 768px)
   ========================================================================== */
@media (max-width: 768px) {
  .research-page {
    padding: 10px 10px 30px !important;
  }

  .research-hero,
  .research-hero-pro {
    padding: 16px 14px !important;
    gap: 14px !important;
    border-radius: 16px !important;
  }

  .research-hero h1 {
    font-size: 22px !important;
    line-height: 1.15 !important;
  }

  .research-hero p {
    font-size: 13px !important;
    line-height: 1.5 !important;
  }

  .research-mini-stats {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 6px !important;
    margin-top: 10px !important;
  }

  .research-mini-stats span {
    padding: 4px 8px !important;
    font-size: 10.5px !important;
  }

  .research-warning {
    width: 100% !important;
    padding: 10px 12px !important;
    border-radius: 10px !important;
    font-size: 11.5px !important;
  }

  /* Tabs on Phone */
  .research-tabs {
    display: flex !important;
    flex-wrap: nowrap !important;
    overflow-x: auto !important;
    gap: 6px !important;
    padding: 2px 2px 8px !important;
    -webkit-overflow-scrolling: touch !important;
    margin: 12px 0 16px !important;
  }

  .research-tabs button {
    flex: 0 0 auto !important;
    min-width: 125px !important;
    padding: 9px 12px !important;
    font-size: 12px !important;
  }

  /* Single column studio layouts */
  .studio-layout,
  .simulation-builder-grid,
  .impact-explorer-grid,
  .molecular-studio-shell,
  .dna-studio-shell {
    grid-template-columns: 1fr !important;
    gap: 14px !important;
  }

  .studio-graph-shell,
  .studio-molecule-svg {
    height: 320px !important;
    min-height: 320px !important;
    touch-action: pan-y !important;
  }

  .hra-body-viewer,
  .hra-result-layout > .hra-body-viewer,
  .d3-organ-intel-panel {
    height: 300px !important;
    min-height: 300px !important;
    touch-action: pan-y !important;
  }

  .studio-controls,
  .simulation-controls {
    width: 100% !important;
  }

  .studio-controls .btn,
  .simulation-controls .btn {
    width: 100% !important;
    min-height: 42px !important;
  }

  /* Face capture panel on mobile */
  .face-capture-card {
    padding: 14px !important;
    border-radius: 14px !important;
  }

  .face-capture-stage {
    width: 100% !important;
    height: auto !important;
    max-height: 300px !important;
  }

  .face-capture-stage video,
  .face-capture-stage canvas {
    max-width: 100% !important;
    height: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ResearchPage.responsive.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;;+EAE+E;AAC/E;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;;IAEE,iCAAiC;IACjC,kCAAkC;IAClC,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,8CAA8C;IAC9C,2BAA2B;EAC7B;;EAEA,8BAA8B;EAC9B;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;IACnB,gCAAgC;IAChC,4CAA4C;IAC5C,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA,6BAA6B;EAC7B;;;;IAIE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;;;IAGE,wBAAwB;IACxB,4BAA4B;EAC9B;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,kCAAkC;EACpC;;EAEA;;IAEE,6BAA6B;IAC7B,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA,kBAAkB;EAClB;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;IACnB,+BAA+B;IAC/B,4CAA4C;IAC5C,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA,iCAAiC;EACjC;;;;;IAKE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;IACxB,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;;;IAGE,wBAAwB;IACxB,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA,iCAAiC;EACjC;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;IAC1B,uBAAuB;EACzB;AACF","sourcesContent":["/* ==========================================================================\n   ResearchPage.responsive.css\n   Responsive Stylesheet for Pharmacology & Molecular Simulation Lab\n   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED\n   ========================================================================== */\n\n/* ==========================================================================\n   IPAD & TABLETS (max-width: 1024px)\n   ========================================================================== */\n@media (max-width: 1024px) {\n  .research-page {\n    width: 100%;\n    max-width: 100vw;\n    padding: 14px 18px 40px !important;\n    overflow-x: hidden;\n  }\n\n  .research-hero,\n  .research-hero-pro {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 16px !important;\n    padding: 22px !important;\n  }\n\n  .research-hero h1 {\n    font-size: clamp(26px, 4.2vw, 36px) !important;\n    line-height: 1.1 !important;\n  }\n\n  /* Horizontal scrolling tabs */\n  .research-tabs {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    overflow-x: auto !important;\n    gap: 8px !important;\n    padding: 4px 2px 10px !important;\n    -webkit-overflow-scrolling: touch !important;\n    scrollbar-width: none !important;\n  }\n\n  .research-tabs::-webkit-scrollbar {\n    display: none !important;\n  }\n\n  .research-tabs button {\n    flex: 0 0 auto !important;\n    min-width: 140px !important;\n    padding: 10px 16px !important;\n    border-radius: 10px !important;\n  }\n\n  /* Studio grids to 1 column */\n  .studio-layout,\n  .simulation-builder-grid,\n  .impact-explorer-grid,\n  .molecular-studio-shell {\n    grid-template-columns: 1fr !important;\n    gap: 18px !important;\n  }\n\n  .studio-graph-shell,\n  .studio-molecule-svg {\n    height: 420px !important;\n    min-height: 420px !important;\n  }\n\n  .hra-body-viewer,\n  .hra-result-layout > .hra-body-viewer,\n  .d3-organ-intel-panel {\n    height: 420px !important;\n    min-height: 420px !important;\n  }\n}\n\n/* ==========================================================================\n   MOBILE PHONES (max-width: 768px)\n   ========================================================================== */\n@media (max-width: 768px) {\n  .research-page {\n    padding: 10px 10px 30px !important;\n  }\n\n  .research-hero,\n  .research-hero-pro {\n    padding: 16px 14px !important;\n    gap: 14px !important;\n    border-radius: 16px !important;\n  }\n\n  .research-hero h1 {\n    font-size: 22px !important;\n    line-height: 1.15 !important;\n  }\n\n  .research-hero p {\n    font-size: 13px !important;\n    line-height: 1.5 !important;\n  }\n\n  .research-mini-stats {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    gap: 6px !important;\n    margin-top: 10px !important;\n  }\n\n  .research-mini-stats span {\n    padding: 4px 8px !important;\n    font-size: 10.5px !important;\n  }\n\n  .research-warning {\n    width: 100% !important;\n    padding: 10px 12px !important;\n    border-radius: 10px !important;\n    font-size: 11.5px !important;\n  }\n\n  /* Tabs on Phone */\n  .research-tabs {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    overflow-x: auto !important;\n    gap: 6px !important;\n    padding: 2px 2px 8px !important;\n    -webkit-overflow-scrolling: touch !important;\n    margin: 12px 0 16px !important;\n  }\n\n  .research-tabs button {\n    flex: 0 0 auto !important;\n    min-width: 125px !important;\n    padding: 9px 12px !important;\n    font-size: 12px !important;\n  }\n\n  /* Single column studio layouts */\n  .studio-layout,\n  .simulation-builder-grid,\n  .impact-explorer-grid,\n  .molecular-studio-shell,\n  .dna-studio-shell {\n    grid-template-columns: 1fr !important;\n    gap: 14px !important;\n  }\n\n  .studio-graph-shell,\n  .studio-molecule-svg {\n    height: 320px !important;\n    min-height: 320px !important;\n    touch-action: pan-y !important;\n  }\n\n  .hra-body-viewer,\n  .hra-result-layout > .hra-body-viewer,\n  .d3-organ-intel-panel {\n    height: 300px !important;\n    min-height: 300px !important;\n    touch-action: pan-y !important;\n  }\n\n  .studio-controls,\n  .simulation-controls {\n    width: 100% !important;\n  }\n\n  .studio-controls .btn,\n  .simulation-controls .btn {\n    width: 100% !important;\n    min-height: 42px !important;\n  }\n\n  /* Face capture panel on mobile */\n  .face-capture-card {\n    padding: 14px !important;\n    border-radius: 14px !important;\n  }\n\n  .face-capture-stage {\n    width: 100% !important;\n    height: auto !important;\n    max-height: 300px !important;\n  }\n\n  .face-capture-stage video,\n  .face-capture-stage canvas {\n    max-width: 100% !important;\n    height: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
